export class ArticleListConfig {
  type = 'all';

  filters: {
    discipline?: string,
    limit?: number,
    offset?: number
  } = {};
}



// WEBPACK FOOTER //
// ./src/app/shared/models/article-list-config.model.ts